<div class="nothing">
  <div class="title">英跃学堂</div>
  <img src="../assets/picture/learningmap/no-course.png" alt="">
  <p style="width: 100%; font-size: 0.3rem;color: white;text-align: center" [innerHtml]="text? text: '您目前没有可学习的课程' " ></p>
</div>



// WEBPACK FOOTER //
// ./src/app/learning-map-nothing.component.html